<template>
  <div>
    <Card>
      <p slot="title">
        <Icon type="ios-settings"></Icon>
        设备管理
      </p>
      <div class="search-form">
        <Form ref="searchForm" :model="searchForm" inline :label-width="70">
          <FormItem label="设备名称">
            <Input
              type="text"
              v-model="searchForm.deviceName"
              placeholder="请输入设备名称"
              clearable
              style="width: 200px"
            />
          </FormItem>
          <FormItem style="margin-left: 10px">
            <Button type="primary" @click="handleSearch">
              <Icon type="ios-search" />
              查询
            </Button>
            <Button @click="handleReset" style="margin-left: 10px">
              <Icon type="md-refresh" />
              重置
            </Button>
            <Button type="success" @click="handleAdd" style="margin-left: 10px">
              <Icon type="md-add" />
              添加设备
            </Button>
          </FormItem>
        </Form>
      </div>
    </Card>

    <Card style="margin-top: 10px">
      <Table
        :loading="loading"
        border
        :columns="columns"
        :data="data"
        sortable="custom"
        stripe
      ></Table>
      <Row type="flex" justify="end" class="page">
        <Page
          :current="page.current"
          :total="page.total"
          :page-size="page.size"
          @on-change="changePage"
          @on-page-size-change="changePageSize"
          :page-size-opts="[10, 20, 50]"
          size="small"
          show-total
          show-elevator
          show-sizer
        ></Page>
      </Row>
    </Card>

    <!-- 添加/编辑模态框 -->
    <Modal
      :title="modalTitle"
      v-model="modalVisible"
      :mask-closable="false"
      :width="700"
      @on-ok="handleSubmit"
      @on-cancel="handleCancel"
    >
      <Form ref="form" :model="form" :rules="formRules" :label-width="120">
        <FormItem label="设备名称" prop="deviceName">
          <Input v-model="form.deviceName" placeholder="请输入设备名称" />
        </FormItem>
        <FormItem label="设备分类" prop="deviceCategory">
          <Select v-model="form.deviceCategory" placeholder="请选择设备分类">
            <Option value="gate">道闸设备</Option>
            <Option value="voice">喊话设备</Option>
            <Option value="led">LED设备</Option>
            <Option value="other">其他设备</Option>
          </Select>
        </FormItem>
        <FormItem label="API地址" prop="apiUrl">
          <Input v-model="form.apiUrl" placeholder="请输入API地址" />
        </FormItem>
        <FormItem label="请求方式" prop="requestMethod">
          <Select v-model="form.requestMethod" placeholder="请选择请求方式">
            <Option value="GET">GET</Option>
            <Option value="POST">POST</Option>
            <Option value="PUT">PUT</Option>
          </Select>
        </FormItem>
        <FormItem label="请求头" prop="requestHeaders">
          <Input
            v-model="form.requestHeaders"
            type="textarea"
            :rows="3"
            placeholder='JSON格式，例如: {"Content-Type":"application/json"}'
          />
        </FormItem>
        <FormItem label="请求参数" prop="requestParams">
          <Input
            v-model="form.requestParams"
            type="textarea"
            :rows="3"
            placeholder='JSON格式，支持占位符 {msg}，例如: {"message":"{msg}"}'
          />
        </FormItem>
        <FormItem label="设备图标" prop="deviceIcon">
          <Input v-model="form.deviceIcon" placeholder="例如: md-bluetooth" />
        </FormItem>
        <FormItem label="排序" prop="sortOrder">
          <InputNumber v-model="form.sortOrder" :min="0" :max="999" />
        </FormItem>
        <FormItem label="状态" prop="status">
          <i-switch v-model="form.status" :true-value="1" :false-value="0">
            <span slot="open">在线</span>
            <span slot="close">离线</span>
          </i-switch>
        </FormItem>
        <FormItem label="备注">
          <Input
            v-model="form.remark"
            type="textarea"
            :rows="2"
            placeholder="请输入备注"
          />
        </FormItem>
      </Form>
    </Modal>

    <!-- 控制设备模态框（喊话） -->
    <Modal
      title="设备控制"
      v-model="controlModalVisible"
      :mask-closable="false"
      @on-ok="handleControl"
      @on-cancel="controlModalVisible = false"
    >
      <Form :label-width="80">
        <FormItem label="设备名称">
          <span>{{ currentDevice.deviceName }}</span>
        </FormItem>
        <FormItem label="控制内容" v-if="currentDevice.deviceCategory === 'voice'">
          <Input
            v-model="controlMsg"
            type="textarea"
            :rows="3"
            placeholder="请输入喊话内容"
          />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import {
    controlDevice,
    delDevice,
    getDeviceList,
    saveDevice,
    updateDevice,
    updateDeviceStatus
} from "@/api/index";

export default {
  name: "deviceMgr",
  data() {
    return {
      loading: false,
      searchForm: {
        deviceName: ""
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      data: [],
      columns: [
        {
          title: "设备名称",
          key: "deviceName",
          minWidth: 150
        },
        {
          title: "设备分类",
          key: "deviceCategory",
          width: 120,
          align: "center",
          render: (h, params) => {
            const typeMap = {
              gate: "道闸设备",
              voice: "喊话设备",
              led: "LED设备",
              other: "其他设备"
            };
            return h("span", typeMap[params.row.deviceCategory] || "-");
          }
        },
        {
          title: "API地址",
          key: "apiUrl",
          minWidth: 200,
          ellipsis: true,
          tooltip: true
        },
        {
          title: "请求方式",
          key: "requestMethod",
          width: 100,
          align: "center"
        },
        {
          title: "状态",
          key: "status",
          width: 100,
          align: "center",
          render: (h, params) => {
            return h(
              "i-switch",
              {
                props: {
                  value: params.row.status === 1,
                  trueValue: 1,
                  falseValue: 0
                },
                on: {
                  "on-change": val => {
                    this.handleStatusChange(params.row.id, val ? 1 : 0);
                  }
                }
              },
              [
                h("span", { slot: "open" }, "在线"),
                h("span", { slot: "close" }, "离线")
              ]
            );
          }
        },
        {
          title: "排序",
          key: "sortOrder",
          width: 80,
          align: "center"
        },
        {
          title: "操作",
          key: "action",
          width: 220,
          align: "center",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.handleControl(params.row);
                    }
                  }
                },
                "控制"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.handleEdit(params.row);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.handleDelete(params.row);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      modalVisible: false,
      modalTitle: "添加设备",
      form: {
        id: null,
        deviceName: "",
        deviceCategory: "",
        apiUrl: "",
        requestMethod: "POST",
        requestHeaders: "",
        requestParams: "",
        deviceIcon: "",
        sortOrder: 0,
        status: 1,
        remark: ""
      },
      formRules: {
        deviceName: [
          { required: true, message: "请输入设备名称", trigger: "blur" }
        ],
        deviceCategory: [
          { required: true, message: "请选择设备分类", trigger: "change" }
        ],
        apiUrl: [
          { required: true, message: "请输入API地址", trigger: "blur" }
        ],
        requestMethod: [
          { required: true, message: "请选择请求方式", trigger: "change" }
        ]
      },
      controlModalVisible: false,
      currentDevice: {},
      controlMsg: ""
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      const params = {
        ...this.searchForm,
        current: this.page.current,
        size: this.page.size
      };
      getDeviceList(params)
        .then(res => {
          if (res.success) {
            this.data = res.result.records;
            this.page.total = res.result.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSearch() {
      this.page.current = 1;
      this.loadData();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm = {
        deviceName: ""
      };
      this.page.current = 1;
      this.loadData();
    },
    changePage(current) {
      this.page.current = current;
      this.loadData();
    },
    changePageSize(size) {
      this.page.size = size;
      this.page.current = 1;
      this.loadData();
    },
    handleAdd() {
      this.modalTitle = "添加设备";
      this.modalVisible = true;
      this.$refs.form && this.$refs.form.resetFields();
      this.form = {
        id: null,
        deviceName: "",
        deviceCategory: "",
        apiUrl: "",
        requestMethod: "POST",
        requestHeaders: "",
        requestParams: "",
        deviceIcon: "",
        sortOrder: 0,
        status: 1,
        remark: ""
      };
    },
    handleEdit(row) {
      this.modalTitle = "编辑设备";
      this.modalVisible = true;
      this.$nextTick(() => {
        this.form = {
          id: row.id,
          deviceName: row.deviceName,
          deviceCategory: row.deviceCategory,
          apiUrl: row.apiUrl,
          requestMethod: row.requestMethod,
          requestHeaders: row.requestHeaders,
          requestParams: row.requestParams,
          deviceIcon: row.deviceIcon,
          sortOrder: row.sortOrder,
          status: row.status,
          remark: row.remark
        };
      });
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const api = this.form.id ? updateDevice : saveDevice;
          api(this.form).then(res => {
            if (res.success) {
              this.$Message.success(res.message);
              this.modalVisible = false;
              this.loadData();
            } else {
              this.$Message.error(res.message);
            }
          });
        }
      });
    },
    handleCancel() {
      this.modalVisible = false;
    },
    handleDelete(row) {
      this.$Modal.confirm({
        title: "确认删除",
        content: `确定要删除设备"${row.deviceName}"吗？`,
        onOk: () => {
          delDevice(row.id).then(res => {
            if (res.success) {
              this.$Message.success("删除成功");
              this.loadData();
            } else {
              this.$Message.error(res.message);
            }
          });
        }
      });
    },
    handleStatusChange(id, status) {
      updateDeviceStatus({ id, status }).then(res => {
        if (res.success) {
          this.$Message.success("状态更新成功");
          this.loadData();
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    handleControlOpen(row) {
      this.currentDevice = row;
      this.controlMsg = "";
      this.controlModalVisible = true;
    },
    handleControl(row) {
      // 如果是从表格按钮点击，先打开模态框
      if (row && row.id) {
        this.handleControlOpen(row);
        return;
      }

      // 如果是从模态框确认按钮，执行控制
      const params = {
        deviceId: this.currentDevice.id
      };
      if (this.currentDevice.deviceCategory === "voice") {
        if (!this.controlMsg) {
          this.$Message.warning("请输入喊话内容");
          return;
        }
        params.msg = this.controlMsg;
      }

      controlDevice(params).then(res => {
        if (res.success) {
          this.$Message.success("设备控制成功");
          this.controlModalVisible = false;
        } else {
          this.$Message.error(res.message);
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.search-form {
  padding: 10px 0;
}
.page {
  margin-top: 10px;
}
</style>


